import {useCallback, memo, useEffect, useState, useContext} from 'react';

import {isEmpty} from 'lodash';
import styled from 'styled-components';

import {getLatLngFromCookie} from '~/shared/utils/cookies';
import {AddressViewValuesMap} from '~/shared/consts/addressConsts';
import _DropDown from '~/shared/components/DropDown';
import {getLocalizationService} from '~/shared/services/localisationService';
import {handleRefreshToken} from '~/shared/services/auth';
import {body16Normal} from '~/shared/theme/typography';
import {is401Error} from '~/shared/services/apiErrorService';

import {
  BlockHeader,
  TitleText,
  BackIcon,
  AddressDropdownButton as BackButton,
  FormContainer,
  FormText,
  ButtonBar,
  AddAddressActionButton,
} from './styled.addressDropdown';
import {AddressDropdownContext} from './context';

const DropDown = styled(_DropDown)`
  z-index: 2;
  ${body16Normal}
`;

const AddCompanyAddress = ({onViewChange, addCompanyAddress}) => {
  const {t} = getLocalizationService();
  const {companyAddresses, getCompanyAddresses} = useContext(AddressDropdownContext);

  const getAddresses = useCallback(async () => {
    const latlng = getLatLngFromCookie() || {};
    try {
      await getCompanyAddresses(latlng);
    } catch (e) {
      if (is401Error(e)) {
        await handleRefreshToken(e, getAddresses);
      }
    }
  }, [getCompanyAddresses]);

  useEffect(() => {
    getAddresses();
  }, [getAddresses]);

  const [selectedCompanyAddressId, setSelectedCompanyAddressId] = useState();

  const noOptionsMessage = () => t('addresses_not_found');
  const onSubmit = () => addCompanyAddress(selectedCompanyAddressId);

  return (
    <>
      <BlockHeader>
        <TitleText>{t('add_company_address')}</TitleText>
        <BackButton data-test-id="addressDropdownBackBtn" onClick={() => onViewChange(AddressViewValuesMap.MAIN)} aria-label={t('back')}>
          <BackIcon />
        </BackButton>
      </BlockHeader>
      <FormContainer adding={1}>
        <FormText>{t('so_we_will_be_able_to_show_you_the_best_results')}</FormText>

        <DropDown
          data-test-id="companyAddressSelect"
          inputId="companyAddressSearchInput"
          name="add-company"
          options={companyAddresses}
          placeholder={isEmpty(companyAddresses) ? `${t('loading')}...` : t('select_address')}
          noOptionsMessage={noOptionsMessage}
          onChange={({companyAddressId}) => setSelectedCompanyAddressId(companyAddressId)}
          isDisabled={isEmpty(companyAddresses)}
          getOptionValue={({companyAddressId}) => companyAddressId}
          getOptionLabel={({companyAddressString}) => companyAddressString}
          isSearchable
          autoFocus
        />
      </FormContainer>
      <ButtonBar center>
        <AddAddressActionButton data-test-id="addCompanyAddressBtn" disabled={!selectedCompanyAddressId} onClick={onSubmit}>
          {t('add')}
        </AddAddressActionButton>
      </ButtonBar>
    </>
  );
};

export default memo(AddCompanyAddress);
